import React, { Component } from "react";
import { Link } from "react-router-dom";
import redux from "../../common/Redux";
import Header from "../../components/Header";
import Modal from "../../components/Modal";
import { root_url } from "../../services/API";
import routes from "../../routes/URL"

import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Container,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputLabel,
  Switch,
  MenuItem,
  Select as MuiSelect,
  IconButton,
  Tabs,
  Tab,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material"
class RestaurantListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restaurants: [], // ✅ Removed dummy data

      isAddModalOpen: false,
  newRestaurant: {
    name: "",
    email: "",
    mobile: "",
    hotel_id: "",
    adhar_number: ""
  }
    };
  }
  componentDidMount() {
    this.fetchRestaurants();
  }

    fetchRestaurants = async () => {
    const parentHotelId = this.props.selectedHotelId?.id;

    if (!parentHotelId) {
      console.error("Hotel ID not found in props.");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${root_url}/api/hotelowner/hotel/getHotelOutlets/${parentHotelId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Failed to fetch outlets");
      }

      const data = await response.json();
      this.setState({ restaurants: data.data || [] });
    } catch (error) {
      console.error("Error fetching restaurant data:", error);
    }
  };
openAddModal = () => {
  this.setState({
    isAddModalOpen: true,
    newRestaurant: {
      ...this.state.newRestaurant,
      hotel_id: this.props.selectedHotelId?.id || ""
    }
  });
};


  closeAddModal = () => {
    this.setState({ 
      isAddModalOpen: false,
  newRestaurant: {
    name: "",
    email: "",
    mobile: "",
    hotel_id: "",
    adhar_number: ""
  }
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      newRestaurant: {
        ...prevState.newRestaurant,
        [name]: value
      }
    }));
  };

handleAddRestaurant = async () => {
  const { name, email, mobile, hotel_id, adhar_number } = this.state.newRestaurant;

  if (!name || !email || !mobile || !hotel_id || !adhar_number) {
    alert("All fields are required.");
    return;
  }

  const token = localStorage.getItem("token"); // Or wherever you're storing the token

  try {
    const response = await fetch(`${root_url}/api/hotelowner/hotel/createOutlet`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        name,
        email,
        mobile,
        hotel_id,
        adhar_number
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to create outlet.");
    }

    const data = await response.json();
    console.log("Outlet Created:", data);
    await this.fetchRestaurants(); // 👈 Refresh list after adding


    // Reset form
    this.setState({
      isAddModalOpen: false,
      newRestaurant: {
        name: "",
        email: "",
        mobile: "",
        hotel_id: "",
        adhar_number: ""
      }
    });
  } catch (error) {
    console.error("Error:", error);
    alert("Failed to create outlet: " + error.message);
  }
};


  render() {
    return (
      <div className="container-fluid" style={{ padding: "24px"}}>
 <div
          style={{
            display: "flex",
            // flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Header title="Outlet" />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className="btn"
              style={{ backgroundColor: "#FFC857", color: "#000", fontWeight: "700" }}
              onClick={() => {
                // Navigate to create coupon page
                this.props.history.push(routes.admin.outlate.create)
              }}
            >
              + Add Outlet
            </div>
          </div>
        </div>

        {/* <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "24px",
          marginTop: "24px"
        }}>
          {this.state.restaurants.length > 0 && this.state.restaurants.map(restaurant => (
  <div key={restaurant.id} style={{
    backgroundColor: "white",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.2s",
    ":hover": {
      transform: "translateY(-4px)"
    }
  }}>
    <img 
      src={restaurant.image} 
      alt={restaurant.name}
      style={{
        width: "100%",
        height: "180px",
        objectFit: "cover"
      }}
    />
    <div style={{ padding: "16px" }}>
      <h3 style={{ margin: "0 0 8px 0", color: "#333" }}>{restaurant.name}</h3>
      <p style={{ 
        margin: "0 0 8px 0", 
        color: "#666",
        fontSize: "14px"
      }}>
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          style={{ verticalAlign: "middle", marginRight: "4px" }}
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        {restaurant.address}
      </p>
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <span style={{
          backgroundColor: "#f0f0f0",
          color: "#555",
          padding: "4px 8px",
          borderRadius: "4px",
          fontSize: "12px"
        }}>
          {restaurant.cuisine}
        </span>
        <div style={{ display: "flex", alignItems: "center" }}>
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="#ffc107" 
            stroke="#ffc107" 
            style={{ marginRight: "4px" }}
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
          </svg>
          <span style={{ fontWeight: "600" }}>{restaurant.rating}</span>
        </div>
      </div>
    </div>
  </div>
))}

        </div>

        {/* Add Restaurant Modal */}
       {/* <Modal
  visible={this.state.isAddModalOpen}
  onClose={this.closeAddModal}
  title="Add New Outlet"
>
  <div style={{ padding: "16px" }}>
    <div style={{ marginBottom: "16px" }}>
      <TextField
        label="Name"
        name="name"
        value={this.state.newRestaurant.name}
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: "#02111B",
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ddd',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#999',
          },
          '& .MuiInputBase-input': {
            color: '#999',
          },
        }}
      />
    </div>

    <div style={{ marginBottom: "16px" }}>
      <TextField
        label="Email"
        name="email"
        type="email"
        value={this.state.newRestaurant.email}
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: "#02111B",
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ddd',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#999',
          },
          '& .MuiInputBase-input': {
            color: '#999',
          },
        }}
      />
    </div>

    <div style={{ marginBottom: "16px" }}>
      <TextField
        label="Mobile"
        name="mobile"
        value={this.state.newRestaurant.mobile}
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: "#02111B",
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ddd',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#999',
          },
          '& .MuiInputBase-input': {
            color: '#999',
          },
        }}
      />
    </div>

    <div style={{ marginBottom: "16px" }}>
      <TextField
        label="Hotel ID"
        name="hotel_id"
        value={this.state.newRestaurant.hotel_id}
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: "#02111B",
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ddd',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#999',
          },
          '& .MuiInputBase-input': {
            color: '#999',
          },
        }}
      />
    </div>

    <div style={{ marginBottom: "16px" }}>
      <TextField
        label="Adhar Number"
        name="adhar_number"
        value={this.state.newRestaurant.adhar_number}
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: "#02111B",
            '& fieldset': {
              borderColor: '#ddd',
            },
            '&:hover fieldset': {
              borderColor: '#ddd',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#999',
          },
          '& .MuiInputBase-input': {
            color: '#999',
          },
        }}
      />
    </div>

    <Button
      onClick={this.handleAddRestaurant}
      variant="contained"
      color="success"
      sx={{
        float: "right",
        backgroundColor: "#28a745",
        '&:hover': {
          backgroundColor: "#218838",
        },
      }}
    >
      Add Restaurant
    </Button>
  </div>
</Modal>  */}
      </div>
    );
  }
}

export default redux(RestaurantListScreen);